import PromptInput from "common/widgets/PromptList/PromptInput";
import DFButton from "app/widgets/DFButton/DFButton";
const ButtonPromptInput = PromptInput.extend({
    options: {
        name: "ButtonPromptInput",
        template: "<button><span class=\"buttonText\"></span></button>"
    },
    init: function(element, options) {
        PromptInput.fn.init.apply(this, arguments);
        this.text = this.input.find(".buttonText");
        this.text.text(this.options.model.label);
        this.input.addClass("secondary");

        this._updateStyle();
        this._updateSize();

        this.widget = new DFButton(this.input, {
            click: $.proxy(this.onClick, this)
        });

        this.widget.bind("change", this.handleChange);
        this.refresh();
    },

    onInit: function(promptList) {
        PromptInput.fn.onInit.apply(this, arguments);
        var me = this;
        this.bind("buttonClick", function() {
            promptList.trigger("buttonClick", me.options.model);
        });
    },

    destroy: function() {
        this.unbind("buttonClick");
        if (this.widget) {
            this.widget.unbind("change", this.handleChange);
        }

        PromptInput.fn.destroy.apply(this, arguments);
    },

    onClick: function(e) {
        e.preventDefault();
        this.trigger("buttonClick", this.options.model);
    },

    getMinSize: function() {
        var minSize = PromptInput.fn.getMinSize.apply(this, arguments);
        minSize.width = 30;
        minSize.height = 22;
        return minSize;
    },

    getCorrectedMinSize: function() {
        var minSize = this.getMinSize();
        var textWidth = this.text.width();
        var textHeight = this.text.height();
        if (textWidth > minSize.width) {
            minSize.width = textWidth;
        }
        if (textHeight > minSize.height) {
            minSize.height = textHeight;
        }
        return minSize;
    },

    updateStyle: function() {
        PromptInput.fn.updateStyle.apply(this, arguments);
        this._updateStyle();
    },

    updateSize: function() {
        PromptInput.fn.updateSize.apply(this, arguments);
        this._updateSize();
    },

    /**
     * Override
     */
    styleWidthProperty: function() {
        return "min-width";
    },

    _updateStyle: function() {
        this.setElementStyle(this.element);
    },

    _updateSize: function() {
        if (this.options.width && this.options.height) {
            this.element.parent().css("height", this.options.height + "px");
        }
    }
});
kendo.ui.plugin(ButtonPromptInput);
export default ButtonPromptInput;
